import { render, staticRenderFns } from "./ConferenceForm.vue?vue&type=template&id=2ce2a0ce&scoped=true&"
import script from "./ConferenceForm.vue?vue&type=script&lang=js&"
export * from "./ConferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceForm.vue?vue&type=style&index=0&id=2ce2a0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2a0ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardActions,VCol,VForm,VIcon,VRow,VSelect,VSwitch,VTextField})
